<template>
  <div class="DoubleImgWidget">
    <div class="flex column md-row">
      <div class="item basis-100 md-basis-50 flex column justify-space-between" :style="leftStyle">
        <div class="titles">
          <h3>
            <span class="font-weight-regular metropolis" v-html="subTitle">
            </span>
            <span class="font-weight-bold metropolis" v-html="title"></span>
          </h3>
        </div>
        <div class="logos-wrapper flex">
          <div class="logo" v-for="logo in logos">
            <img :src="logo" alt="" />
          </div>
        </div>
      </div>
      <div class="item md-basis-50 sm-hide padding-zero imgWrapper">
        <img class="responsive-img" v-if="!!rightImgSrc" :src="rightImgSrc" />
      </div>
    </div>
    <div class="ctaLabel" v-if="!!ctaLabel">
      {{ctaLabel}}
    </div>
    <div class="networkLink" v-if="!!ctaText">
      <a :href="ctaHref" @click="onBtnClick">{{ctaText}}</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'DoubleImgWidget',
    components:{
    },
    props: {
      id: {
        type: Number,
        default: 0
      },
      title: {
        type: String,
        default: ""
      },
      subTitle: {
        type: String,
        default: ""
      },
      images: {
        type: Array,
        default: ()=>[]
      },
      logos: {
        type: Array,
        default: ()=>[]
      },
      ctaLabel: {
        type: String,
        default: ""
      }, 
      ctaText: {
        type: String,
        default: ""
      },
      ctaHref: {
        type: String,
        default: ""
      },
    },
    computed: {
      leftStyle(){
        let bg = !!this.images.find((i)=>i.position==='left') ? this.images.find((i)=>i.position==='left').src : '#000',
          obj = {};

        if(bg !== '#000'){
          obj = {
            'background-image': `url(${bg})`
          }
        }else{
          obj = {
            'background-color': bg
          }
        }
        return obj
      },
      rightImgSrc(){
        return !!this.images.find((i)=>i.position==='right') ? this.images.find((i)=>i.position==='right').src : null
      }
    },
    methods: {
      onBtnClick: function(e){
        e.preventDefault();
        if(!!window.location.hash){
          var event = new CustomEvent('hashClicked', {
            detail: {
              a: e.target
            }
          });
          window.dispatchEvent(event);
        }else{
          window.location.href = e.target.getAttribute('href');
        }
      }
    }
  }
</script>

<style lang="less">
  @import (reference) '~@less/_variables';
  @import (reference) '~@less/common';

  @media (max-width: 767px){
    .sm-hide{
      display: none;
    }
  }

  .justify-space-between{
    justify-content: space-between;
  }

  .DoubleImgWidget{

    h3{
      margin: 0;
      color: #fff;
    }
    .titles{
      span{
        display: block;
        font-size: 28px;
        @media (min-width: @bootstrap-md){
          font-size: 20px;
        }
        @media (min-width: @bootstrap-lg){
          font-size: 30px;
        }
        @media (min-width: @bootstrap-xl){
          font-size: 34px;
        }
      }
      p{
        margin: 0;
      }
    }
    .item{
      padding: 15px;
      @media (min-width: @bootstrap-md){
        padding: 20px;
        &.sm-hide{
          display: block !important;
        }
      }
      @media (min-width: @bootstrap-xl){
        padding: 30px;
      }
    }

    .logos-wrapper{
      margin-top: 25px;
      @media (min-width: @bootstrap-md){
        margin-top: 30px;
      }
      @media (min-width: @bootstrap-xl){
        margin-top: 40px;
      }
    }

    .flex{
      display: flex;
      .column{
        flex-direction: column;
      }

      .basis-100{
        flex: 0 0 100%;
      }

      .sm-hide{
        display: none
      }

      @media (min-width: 768px){
        .md-basis-50{
          flex: 0 0 50%;
        }
      }
      

      @media (min-width: 768px){
        .md{
          flex-direction: row
        }
      }
    }

    .logo{
      padding-left: 10px;
      padding-right: 10px;
      border-right: 2px solid #fff;
      &:first-child{
        padding-left: 0;
      }
      &:last-child{
        border-right: none;
        padding-right: 0;
      }
      img{
        max-height: 80px;
        @media (min-width: @bootstrap-md){
          max-height: 60px;
        }
        @media (min-width: @bootstrap-lg){
          max-height: 80px;
        }
        @media (min-width: @bootstrap-xl){
          max-height: 90px;
        }
      }
      
    }

    .item{
      background-size: cover;
      background-position: center;
    }

    .text{
      flex: 1;
      font-family: Helvetica, sans-serif;
      font-weight: bold;
      font-size: 28px;
      line-height: 34px;
      text-align: center;
      color: #fff;
      background: linear-gradient(to bottom, rgba(0,0,0,0.65) 0%, rgba(0,0,0,0) 100%);
    }

    .ctaLabel, .networkLink{
      font-family: -apple-system, BlinkMacSystemFont, sans-serif;
    }

    .ctaLabel{
      color: #555555;
      margin-top: 22px;
    }

    .responsive-img{
      max-width: 100%;
    }

    .padding-zero{
      padding: 0;
    }
  }
</style>
